<template>
  <div class="flex-box">
    <div class="flex-box">
      <el-table
        v-loading="searching"
        ref="table"
        :data="data"
        :stripe="stripe"
        :style="'flex:1;margin-bottom:12px;width:100%;'"
        height="'100%'"
        border
        highlight-current-row>
        <slot/>
      </el-table>

      <el-pagination
        v-if="dispalyPagination"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="size"
        :layout="layout"
        :total="total"
        style="height:44px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>
import { deepCopy } from './utils';

export default {
  props: {
    remoteMethod: {
      type: Function,
      required: true
    },
    dispalyPagination: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default: () => [15, 20, 30, 40, 50]
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    stripe: {
      type: Boolean,
      default: true
    },
    styles: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      postData: {},
      searching: false,
      data: [],
      currentPage: 1,
      size: 20,
      total: 0
    };
  },
  methods: {
    doLayout() {
      this.$refs.table.doLayout();
    },
    async loadData(params) {
      this.currentPage = 1;
      await this._loadData(params);
    },
    async _loadData(params) {
      if (params) {
        this.postData = deepCopy(params);
      }
      this.postData = this.postData || {};
      this.postData.page = this.currentPage;
      this.postData.rows = this.size;

      this.searching = true;
      try {
        const response = await this.remoteMethod(this.postData);
        if (response) {
          const { data, total } = response;
          this.data = data;
          this.total = total;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
          });
        }
      } catch (e) {
        // console.log(e);
      }
      this.searching = false;
    },
    async reload() {
      return this._loadData(this.postData);
    },
    reset() {
      this.postData = {};
      this.searching = false;
      this.data = [];
      this.currentPage = 1;
      this.size = this.pageSize;
      this.total = 0;
    },
    handleSizeChange(size) {
      this.size = size;
      this._loadData();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this._loadData();
    }
  }
};
</script>

<style scoped>
  .flex-box {
    display: flex;
    flex-direction: column;
    flex:1;
  }
</style>



// WEBPACK FOOTER //
// src/components/grid/index.vue?15881ff4